export default __webpack_public_path__ + "static/media/LOGO_MADR_1024.87afc4f3.jpg";